import { render } from "./NotificationWatcher.vue?vue&type=template&id=a379fca6"
import script from "./NotificationWatcher.vue?vue&type=script&lang=js"
export * from "./NotificationWatcher.vue?vue&type=script&lang=js"
script.render = render

export default script